import { post } from './apiClient';

export function createFolder({ path, folderName }) {
  return post('/api/folders', { path, folderName });
}
